import { trackClientEvent } from 'analytics/analytics'

type OfferPagePricingBlockType = 'hotel' | 'hotel_plus_flights'
interface OfferPageHotelFlightsCtaImpressionOptions {
  countryCode: string
  hasDisplayPriceAndCta: boolean
  offerId: string
}

export function trackOfferPageTopCtaClick(): void {
  trackClientEvent({
    subject: 'offer_page_top_cta',
    action: 'view_package_options_click',
    category: 'offer_page',
    type: 'interaction',
  })
}

export function trackOfferPagePricingBlockViewOptionsClick(type: OfferPagePricingBlockType): void {
  trackClientEvent({
    subject: 'offer_page_pricing_block',
    action: `${type}_view_options_click`,
    category: 'offer_page',
    type: 'interaction',
  })
}

export function trackOfferPageHotelFlightsCtaImpression(options: OfferPageHotelFlightsCtaImpressionOptions): void {
  trackClientEvent({
    subject: 'hotel_plus_flights_cta',
    action: 'impression',
    category: 'offer_page',
    type: 'nonInteraction',
    context: [
      {
        schema: 'iglu:com.luxgroup/hotel_plus_flights_cta_context/jsonschema/1-0-0',
        data: {
          countryCode: options.countryCode,
          hasDisplayPriceAndCta: options.hasDisplayPriceAndCta,
          offerId: options.offerId,
        },
      },
    ],
  })
}

export function trackOfferPageSuggestedPackageViewPackageClick(): void {
  trackClientEvent({
    subject: 'offer_page_suggested_package',
    action: 'view_package_click',
    category: 'offer_page',
    type: 'interaction',
  })
}
